<template>
    <div>
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torrea">
                <h1 class="caption__select">
                </h1>
                <map-highlight :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />

                <div>
                    <image-location class="image__location-small canadas-model" :typeImage="typeImage" :urlImg="urlImg"/>
                    <detail-location :typeImage="typeImage"/>
                    <btn-detail style="margin-top:2rem" @clickBtn="openM()" />
               </div>
               <DetailModal :modalShow="modal" @modalHide="closeM">
                <template slot="title-detail">{{ modelDpt.name }}</template>
                 <template slot="content-detail">
                    <Detail />
                 </template>
               </DetailModal>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../../core/rediseno/ButtonsPisos.vue";
import ImageLocation from "../../../core/rediseno/ImageIndividual.vue";
import DetailLocation from "../../../core/rediseno/DetailLocation.vue";
import BtnDetail from "../../../core/rediseno/BtnDetail.vue";
import DetailModal from "../../../core/rediseno/modal/DetailModal.vue";
import Detail from "../detailLocation/Main.vue"

export default {
    name: "Piso",
    components: {
        MapHighlight,
        ImageLocation,
        DetailLocation,
        BtnDetail,
        DetailModal,
        Detail
    },
    data() {
        return {
            id: 35,
            levelId: this.$route.params.idPiso,
            type: "departamentos",
            desarrollo: "canadas_deptos-piso",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
             //image adition
             typeImage: "modeloDeptos",
             urlImg: 'ca%C3%B1adas/deptos/modelos',
            //
            privadas: {
                NIVEL0: {
                    name: 'NIVEL 0',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepas.png',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL1: {
                    name: 'NIVEL 1',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepas.png',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL2: {
                    name: 'NIVEL 2',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepas.png',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles/`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL3: {
                    name: 'NIVEL 3',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepas.png',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
                NIVEL4: {
                    name: 'NIVEL 4',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/mainDepas.png',
                    width: '3699',
                    id: 35,
                    levelId: this.$route.params.idPiso,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.piso}/detalles`,
                    height: '3899',
                    transform: '',
                    viewBox: '0 0 3699 3899'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            modal:false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos",
            levelDept:"getStatusLevel",
            modelDpt:'getStatusA' 
        }),
        development() {
            return { id: this.id, level: this.levelDept.id };
        },
        img() {
            const piso = this.$route.params.piso;
            const pisoSeleccionado = this.privadas[piso];
            return pisoSeleccionado;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        openM(){
            this.modal=true
        },
        closeM(){
            this.modal=false
        },
    },
    async created() {
        /* await this.getAvailableLocations(this.development);
        this.getFilterModelos(this.existFilter) */
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    mounted() {

    }
};
</script>
<style>
@media (min-width:1201px){
    .image__location-small.canadas-model .image__location{
        width: 90%!important;
        margin: auto;
    }
}

@media (max-width:1200px){
    .image__location-small.canadas-model .image__location{
        width: 70%!important;
        margin: auto;
    }
}
</style>
